import api from './api.service';

export interface SettlementOpenSource {
  id: string;
  source_type: string;
  source_document_type: string;
  source_document_id: string;
  party_side: string;
  party_id: string;
  original_amount: number;
  settled_amount: number;
  open_amount: number;
  source_date: string;
  status: string;
  reference_number: string | null;
}

export interface SettlementRegisterRow {
  id: string;
  source_id: string;
  target_id: string;
  settlement_type: string;
  adjusted_amount: number;
  adjustment_date: string;
  created_by: string | null;
  created_at: string;
  source_reference_number: string | null;
  target_reference_number: string | null;
  party_side: string;
  party_id: string;
  legacy_allocation_id: string | null;
  party_name: string | null;
}

export interface SettlementRegisterFilters {
  party_side?: string;
  party_id?: string;
  from_date?: string;
  to_date?: string;
  settlement_type?: string;
}

export async function getSettlementRegister(
  filters?: SettlementRegisterFilters
): Promise<SettlementRegisterRow[]> {
  const params = new URLSearchParams();
  if (filters?.party_side) params.set('party_side', filters.party_side);
  if (filters?.party_id) params.set('party_id', filters.party_id);
  if (filters?.from_date) params.set('from_date', filters.from_date);
  if (filters?.to_date) params.set('to_date', filters.to_date);
  if (filters?.settlement_type) params.set('settlement_type', filters.settlement_type);
  const q = params.toString();
  const url = q ? `/finance/settlement/register?${q}` : '/finance/settlement/register';
  const res = await api.get<{ data?: SettlementRegisterRow[] }>(url);
  const data = (res as any)?.data?.data ?? (res as any)?.data ?? res;
  return Array.isArray(data) ? data : [];
}

export async function getOpenSources(
  partySide: string,
  partyId?: string,
  sourceTypes?: string[]
): Promise<SettlementOpenSource[]> {
  const params = new URLSearchParams();
  params.set('party_side', partySide);
  if (partyId) params.set('party_id', partyId);
  if (sourceTypes?.length) params.set('source_types', sourceTypes.join(','));
  const res = await api.get<{ data?: SettlementOpenSource[] }>(`/finance/settlement/open-sources?${params.toString()}`);
  const data = (res as any)?.data?.data ?? (res as any)?.data ?? res;
  return Array.isArray(data) ? data : [];
}
